module.exports = __webpack_public_path__ + "img/EgyptTechPriestSpeed1_ua.e7d0b745.webp";